module.exports = __webpack_public_path__ + "img/shopping-bag-blue.4103e2ca.svg";